import React from 'react';
import {Checkbox, FormControlLabel} from "@material-ui/core";

import './styles.scss';

import checkboxCtor from '../../utils/checkboxCtor';

const Input = ({
 id,
 name,
 onChange,
 value,
 disabled
}) => (
  <Checkbox
    id={id}
    checked={value || false}
    onChange={() => {
      onChange(name, !value)
    }}
    disabled={disabled}
    icon={(
      <svg className="auth-checkbox__icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="31" height="31" rx="8.5" fill="white" stroke="black"/>
      </svg>
    )}
    checkedIcon={(
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="31" height="31" rx="8.5" fill="white" stroke="black"/>
        <rect x="4" y="4" width="24" height="24" rx="6" fill="#5B47FF"/>
      </svg>
    )}
  />
);

const Component = ({
 className,
 label,
 checkboxProps,
}) => {
  return (
    <FormControlLabel
      id={checkboxProps.id}
      className={[
        'auth-checkbox',
        checkboxProps.disabled ? ' disabled' : '',
        checkboxProps.showError ? ' error' : '',
        className
      ].join(' ')}
      label={label}
      control={
        <Input {...checkboxProps} />
      }
    />
  )
}

export default checkboxCtor(Component);
